import { render, staticRenderFns } from "./Workshop1.vue?vue&type=template&id=29d8ec1b&"
import script from "./Workshop1.vue?vue&type=script&lang=js&"
export * from "./Workshop1.vue?vue&type=script&lang=js&"
import style0 from "./Workshop1.vue?vue&type=style&index=0&id=29d8ec1b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports